<template>
  <el-dialog
      title="Cập nhật khoản"
      :visible.sync="dialogVisibleUpdate"
      width="1150px"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      @open="handleOpen"
      top="4vh"
  >
    <el-form
        label-width="160px"
        :model="dataInput"
        label-position="left"
        :rules="rules"
        ref="dataInput"
    >
      <el-row :gutter="20">
        <el-col :span="16">
          <el-form-item label="Tên khoản" prop="name">
            <el-input v-model="dataInput.name" placeholder="Nhập tên khoản"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Loại" prop="category">
            <el-select
                v-model="dataInput.category"
                @change="resetAttendanceMethod()"
                placeholder="Loại"
            >
              <el-option label="Thu" value="in"></el-option>
              <el-option label="Chi" value="out"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="Mô tả" prop="description">
        <el-input
            :rows="2"
            type="textarea"
            autosize
            v-model="dataInput.description"
            placeholder="Nhập mô tả"
        ></el-input>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="Số lượng" prop="number">
            <el-input-number
                v-model="dataInput.number"
                :precision="0"
                :min="1"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Đơn giá" prop="price">
            <el-currency-input v-model="dataInput.price" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="Giảm giá" prop="discount">
            <el-radio-group v-model="dataInput.discount">
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="dataInput.discount">
          <el-form-item label="Loại giảm giá" prop="discountType">
            <el-select v-model="dataInput.discountType" placeholder="Loại">
              <el-option label="Phần trăm" value="percent"></el-option>
              <el-option label="Tiền" value="money"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="dataInput.discount">
          <el-form-item
              :label="dataInput.discountType === 'percent' ? 'Phần trăm giảm' : 'Tiền giảm'"
              prop="discountNumber"
          >
            <el-input-number
                v-if="dataInput.discountType === 'percent'"
                v-model="dataInput.discountNumber"
                :precision="0"
                :min="0"
                :max="100"
            >
            </el-input-number>
            <el-currency-input
                v-else-if="dataInput.discountType === 'money'"
                v-model="dataInput.discountNumber"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col>
          <el-form-item label="Thành tiền" prop="discountPrice">
            <currency-input
                disabled
                style="
                padding: 10px;
                width: 98%;
                text-align: right;
                background: #e7e9ec;
                border: 1px solid #dcdfe6;
                font-weight: bold;
              "
                v-model="dataInput.discountPrice"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col>
          <el-form-item label="Số tiền bằng chữ">
            <span style="font-weight: bold; font-style: italic;">{{ numberToWordsVN(dataInput.discountPrice) }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Trạng thái sử dụng" prop="usingStatus">
            <el-radio-group v-model="dataInput.usingStatus">
              <el-radio :label="true">Đang sử dụng</el-radio>
              <el-radio :label="false">Ngừng sử dụng</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="Áp dụng điểm danh" prop="attendance">
            <el-radio-group v-model="dataInput.attendance">
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="dataInput.attendance">
          <el-form-item label="Phương pháp tính" prop="attendancePaid">
            <el-radio-group
                v-model="dataInput.attendancePaid"
                @change="resetAttendanceMethod()"
            >
              <el-radio label="before">Tính trước</el-radio>
              <el-radio label="after">Tính sau</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="dataInput.attendance">
        <span v-if="dataInput.attendancePaid === 'before'">
          <el-col :span="8">
            <el-form-item label="Loại điểm danh" prop="attendanceType">
              <el-select
                  v-model="dataInput.attendanceType"
                  @change="changeAttendanceTypeMethod()"
                  placeholder="Chọn loại điểm danh"
              >
                <el-option
                    v-for="item in this.$funcData.funcAttendanceTypeNewList()"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="dataInput.attendanceType !== 'pickupLate'">
            <el-form-item label="Chi tiết" prop="attendanceDetail">
              <el-select
                  v-model="dataInput.attendanceDetail"
                  placeholder="Chọn chi tiết"
                  style="width: 250px"
              >
                <el-option
                    v-for="item in attendanceDetailNewList"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </span>
        <span v-else-if="dataInput.attendancePaid === 'after'">
          <el-col :span="8">
            <el-form-item label="Loại điểm danh" prop="attendanceType">
              <el-select
                  v-model="dataInput.attendanceType"
                  @change="changeAttendanceTypeMethod()"
                  placeholder="Chọn loại điểm danh"
              >
                <el-option
                    v-for="item in attendanceTypeList"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="dataInput.attendanceType !== 'pickupLate'">
            <el-form-item label="Chi tiết" prop="attendanceDetail">
              <el-select
                  v-model="dataInput.attendanceDetail"
                  placeholder="Chọn chi tiết"
                  style="width: 250px"
              >
                <el-option
                    v-for="item in attendanceDetailList"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </span>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="danger" size="medium" @click="closeDialog()">
        <i class="el-icon-circle-close" />
        <span>{{ $t("button.close") }}</span>
      </el-button>
      <el-button
          type="success"
          size="medium"
          :loading="loadingButton"
          mini
          @click="submitForm()"
      >
        <i class="el-icon-circle-check" />
        <span>{{ $t("button.save") }}</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import ElCurrencyInput from "@/components/ElCurrencyInput.vue";
import revenueManagementService from "@/services/Finance_Kids_V2/RevenueManagementService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import globalMixin from "@/global/mixin/global.mixin";

const valAttendanceTypeList = [
  { key: "goSchool", value: "Điểm danh đi học" },
  { key: "absentYes", value: "Nghỉ có phép" },
  { key: "absentNo", value: "Nghỉ không phép" },
  { key: "eat", value: "Điểm danh ăn" },
  { key: "pickupLate", value: "Đón muộn" },
];
const valAttendanceGoSchoolList = [
  { key: "morning", value: "Buổi sáng" },
  { key: "afternoon", value: "Buổi chiều" },
  { key: "evening", value: "Buổi tối" },
  { key: "allDay", value: "Cả ngày" },
];
const valAttendanceEatList = [
  { key: "eatBreakfast", value: "Bữa sáng" },
  { key: "eatBreakfastSecond", value: "Bữa phụ sáng" },
  { key: "eatLunch", value: "Bữa trưa" },
  { key: "eatAfternoon", value: "Bữa chiều" },
  { key: "eatAfternoonSecond", value: "Bữa phụ chiều" },
  { key: "eatDinner", value: "Bữa tối" },
  { key: "allDay", value: "Cả ngày" },
];

const valAttendanceDetailInNewList = [
  { key: "eatBreakfast1", value: "Thu tiền bữa sáng (1)" },
  { key: "eatRemain1", value: "Thu tiền bữa còn lại (1)" },
  { key: "eatDay2", value: "Thu tiền gói một ngày (2)" },
];
export default {
  name: "UpdateRevenueDialog",
  components: {
    ElCurrencyInput,
  },
  props: {
    dialogVisibleUpdate: {
      type: Boolean,
      default: () => false
    },
    dataUpdate: {
      type: Object,
      default: () => {}
    },
    exitClassOrGroup:{
      type: Boolean,
      default: () => false
    }
  },

  data() {
    return {
      dataInput: {
        id: 0,
        name: "",
        category: "",
        description: "",
        number: 1,
        price: 0,
        discount: false,
        discountType: "",
        discountNumber: 0,
        discountPrice: 0,
        usingStatus: true,
        attendance: false,
        attendancePaid: "",
        attendanceType: "",
        attendanceDetail: ""
      },
      attendanceTypeList: valAttendanceTypeList,
      attendanceGoSchoolList: valAttendanceGoSchoolList,
      attendanceEatList: valAttendanceEatList,
      attendanceDetailList: [],
      attendanceDetailInNewList: valAttendanceDetailInNewList,
      attendanceDetailNewList: [],
      checkAll: false,
      loadingButton: false,
      rules: {
        name: [
          {
            required: true,
            message: "Tên khoản không được để trống",
            trigger: "blur",
          },
        ],
        number: [
          {
            required: true,
            message: "Số lượng không được để trống",
            trigger: "blur",
          },
        ],
        price: [
          {
            required: true,
            message: "Đơn giá không được để trống",
            trigger: "blur",
          },
        ],
        discountType: [
          {
            required: true,
            message: "Loại giảm giá không được để trống",
            trigger: "change",
          },
        ],
        discountNumber: [
          {
            required: true,
            message: "Thông tin không được để trống",
            trigger: "blur",
          },
        ],
        attendance: [
          {
            required: true,
            message: "Áp dụng điểm danh không được để trống",
            trigger: "change",
          },
        ],
        attendancePaid: [
          {
            required: true,
            message: "Phương pháp tính không được để trống",
            trigger: "change",
          },
        ],
        attendanceType: [
          {
            required: true,
            message: "Loại điểm danh không được để trống",
            trigger: "change",
          },
        ],
        attendanceDetail: [
          {
            required: true,
            message: "Chi tiết không được để trống",
            trigger: "change",
          },
        ],
        type: [
          {
            required: true,
            message: "Kiểu đóng không được để trống",
            trigger: "change",
          },
        ],
        category: [
          {
            required: true,
            message: "Loại không được để trống",
            trigger: "change",
          },
        ],
      },
    };
  },
  mixins: [globalMixin],
  watch: {
    'dataInput.discount': 'calculateDiscountPrice',
    'dataInput.discountType': 'calculateDiscountPrice',
    'dataInput.discountNumber': 'calculateDiscountPrice',
    'dataInput.price': 'calculateDiscountPrice',
    'dataInput.number': 'calculateDiscountPrice',
    changeAttendanceTypeComputed() {
      let dataInputComputed = this.dataInput;
      if (dataInputComputed.attendancePaid === "before") {
        if (dataInputComputed.attendanceType === "eatNew") {
          this.attendanceDetailNewList =
              dataInputComputed.category === "in"
                  ? this.attendanceDetailInNewList
                  : this.$funcData.getAttendanceDetailOutNewList();
        } else if (dataInputComputed.attendanceType === "arriveNew") {
          this.attendanceDetailNewList =
              dataInputComputed.category === "in"
                  ? this.$funcData.getAttendanceDetailArriveInList()
                  : this.$funcData.getAttendanceDetailArriveOutList();
        }
      } else if (dataInputComputed.attendancePaid === "after") {
        if (
            dataInputComputed.attendanceType === "absentYes" ||
            dataInputComputed.attendanceType === "absentNo"
        ) {
          this.attendanceDetailList = this.attendanceGoSchoolList;
        } else if (dataInputComputed.attendanceType === "goSchool") {
          this.attendanceDetailList = this.$funcData.getAttendanceGoSchooList();
        } else if (dataInputComputed.attendanceType === "eat") {
          this.attendanceDetailList = this.attendanceEatList;
        } else if (dataInputComputed.attendanceType === "pickupLate") {
          this.attendanceDetailList = [];
        }
      }
    },
  },
  computed: {
    changeAttendanceTypeComputed() {
      return [this.dataInput.attendanceType, this.dataInput.category];
    },
  },
  methods: {
    calculateDiscountPrice() {
      const data = this.dataInput;
      let finalPrice = 0;

      // Không có giá trị cơ bản
      if (!data.price || !data.number) {
        data.discountPrice = 0;
        return;
      }

      // Không áp dụng giảm giá
      if (!data.discount) {
        data.discountPrice = data.price * data.number;
        this.dataInput.discountNumber = 0
        return;
      }

      // Áp dụng giảm giá
      if (data.discountType === "percent") {
        finalPrice = data.price * ((100 - data.discountNumber) / 100) * data.number;
      } else if (data.discountType === "money") {
        if (data.discountNumber > data.price * data.number) {
          this.$alert("Số tiền giảm không thể lớn hơn tổng tiền", "Thông báo!", {
            confirmButtonText: "Đã hiểu",
            callback: () => {
              this.dataInput.discountNumber = 0;
            },
          });
          finalPrice = data.price * data.number;
        } else {
          finalPrice = data.price * data.number - data.discountNumber;
        }
      }

      // Gán 1 lần duy nhất để tránh vòng lặp
      if (data.discountPrice !== finalPrice) {
        this.dataInput.discountPrice = finalPrice;
      }
    },
    handleOpen() {
      this.dataInput = this.$props.dataUpdate && Object.keys(this.$props.dataUpdate).length > 0
          ? { ...this.$props.dataUpdate }
          : {
            name: "",
            category: "",
            description: "",
            number: 1,
            price: 0,
            discount: false,
            discountType: "",
            discountNumber: 0,
            discountPrice: 0,
            usingStatus: true,
            attendance: false,
            attendancePaid: "",
            attendanceType: "",
            attendanceDetail: ""
          };
    },

    //reset when click x
    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.loadingButton = false;
        this.$refs["dataInput"].resetFields();
      }, 300);
    },
    changeAttendanceTypeMethod() {
      this.dataInput.attendanceDetail = "";
    },
    resetAttendanceMethod() {
      this.dataInput.attendanceType = "";
      this.dataInput.attendanceDetail = "";
    },
    submitForm() {
      this.$refs["dataInput"].validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          revenueManagementService.updateRevenueManagement(this.dataInput)
              .then(() => {
                NotifyMessage.leftCornerNotificationSuccess("Cập nhật thành công!")
                setTimeout(() => {
                  this.closeDialog();
                }, 500);
              })
              .catch((err) => {
                console.log(err)
                NotifyMessage.leftCornerNotificationError("Cập nhật khoản thất bại!");
              })
              .finally(() => {
                setTimeout(() => {
                  this.loadingButton = false;
                }, 500);
              });
        } else {
          console.log("error validate data!");
          return false;
        }
      });
    },

  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__title {
  font-size: 25px;
  color: #606266;
}
/deep/.el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}
/deep/.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}
/deep/.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}
/deep/.el-dialog__body {
  padding-bottom: 5px;
}
/deep/.el-input-number__decrease,
/deep/.el-input-number__increase {
  z-index: 1;
}
.el-input-number {
  width: 100%;
}
</style>
